import axios from "axios/index";
import Router from "../../router";
import store from "../../store";
import { Globals } from "../../global_constants/constants";

export default function apiClientCreator(path) {
  let headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };

  const token = localStorage.getItem("user-token");
  //let CancelToken_ = axios.CancelToken.source();
  const source = axios.CancelToken.source();

  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }

  apiClientCreator.CancelToken = axios.CancelToken;
  apiClientCreator.source = apiClientCreator.CancelToken.source();
  apiClientCreator.cancel = function() {
    apiClientCreator.source.cancel("Operation canceled by the user.");
  };
  const instance = axios.create({
    baseURL: Globals.crm_api_server_endpoint + path,
    headers: headers
  });

  instance.interceptors.request.use(config => {
    config.cancelToken = apiClientCreator.source.token;
    return config;
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }
      if (error && error.response && 401 === error.response.status) {
        if (store.getters["user/isLogged"]) {
          store.dispatch("user/logOut").then(() => {
            return Router.push("/login");
          });
        }
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );

  return instance;
}
